module.exports = __webpack_public_path__ + "b6ed3efc7ae86b8275ce089417adad5c.png";